
import { mapGetters } from "vuex"
import formMixin from "@/mixins/form"
import { scrollToFirstError } from "@/utils/error"

export default formMixin.extend({
  props: {
    isPage: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    model: {} as Record<string, any>,
    isDone: false,
  }),

  fetch () {
    this.fill()
  },

  computed: {
    ...mapGetters("user", ["user"]),

    agreementUrl (): string {
      if (this.$i18n.locale === "ru")
        return "https://wyffest.com/storage/f2a07fae441d036557d9/SNPD_05_02_2026.pdf"
      return "https://wyffest.com/storage/0c35f60ffeec3577ffc8/CONSENT_FOR_PERSONAL_DATA_PROCESSING.pdf"
    },
  },

  methods: {
    fill () {
      const { user } = this
      if (!user) return

      const name = [
        user.lastName,
        user.firstName,
        user.patronymic,
      ]
        .map(n => this.$fmt.localize(n))
        .filter(Boolean)
        .join(" ")

      if (name)
        this.$set(this.model, "name", name)

      if (user.email)
        this.$set(this.model, "email", user.email)
    },

    async onSubmit () {
      const { validationObserver } = this.$refs
      if (!validationObserver) return

      const isValid = await (validationObserver as any).validate()

      if (!isValid) {
        scrollToFirstError()
        return
      }

      this.isLoadingModel = true

      const [, err] = await this.$api.event.sendFeedback(this.model)

      if (err)
        this.handleError(err)
      else
        this.isDone = true

      this.isLoadingModel = false
    },

    reset () {
      this.model = {}
      this.fill()
      this.isDone = false
    },
  },
})
